import {cpsUrl} from 'config/base'
import {ENDPOINT} from 'config/path'
import {resetLoginState} from 'features/Login/login.slice'
import {Fragment, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {resetCommonState} from 'redux/common.slice'
import {type AppDispatch, type RootState} from 'redux/store'
import {get as _get} from 'lodash'

export const clearLocalStorageValues = () => {
    localStorage.removeItem('persist:root')
    localStorage.removeItem('auth')
    localStorage.removeItem('isLoggedIn')
    localStorage.removeItem('access_token')
}

const Logout = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()
    const authToken = useSelector((state: RootState) => state.login.authToken)

    const isLoggedIn = localStorage.getItem('isLoggedIn')

    const checkLogin = () => {
        if (isLoggedIn === 'true') {
            if (localStorage.getItem('NewLogin') === 'true') {
                navigate(ENDPOINT.dashboard)
            } else {
                window.location.href = `${cpsUrl}/lmsweb/signon.jsp`
            }
        } else {
            void dispatch(resetLoginState(_get(authToken, 'data.refresh_token', '')))
            dispatch(resetCommonState())
            clearLocalStorageValues()
            localStorage.setItem('isLoggedIn', 'false')
            if (localStorage.getItem('NewLogin') === 'true') {
                // window.location.href = `${cpsUrl}${ENDPOINT.basePath}${ENDPOINT.login}`
                navigate(ENDPOINT.login)
            } else {
                window.location.href = `${cpsUrl}/lmsweb/signon.jsp`
            }
        }
    }

    useEffect(() => {
        checkLogin()
        return () => {
            checkLogin()
        }
    }, [isLoggedIn, navigate])
    return <Fragment />
}

export default Logout
